<!--suppress ALL -->

<template>
  <el-dialog top="10px"
             width="300"
             :visible.sync="isVisible"
             :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true"
             title="添加新对话">

    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item  label="名称" prop="prompt">
        <el-input v-model="form.title"></el-input>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button class="btn" @click="onSubmit">确 定</el-button>
      <el-button @click="isVisible = false">关闭</el-button>
    </div>
  </el-dialog>

</template>

<script>


export default {
  name: 'ChatGroupAdd',
  data() {
    return {
      isVisible: false,
      title: '',
      agent_id:0,
      form: {
        title: '',
      },
      rules: {},
    }
  },

  components: {},

  mounted: function () {
  },

  methods: {

    init: function (agent_id) {
      this.isVisible = true;
      this.agent_id = agent_id
    },

    onSubmit: function () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.createText();
        } else {
          return false;
        }
      });
    },

    createText: function (catId) {
      let t = this;
      this.$post(
        {
          context: t,
          loading: true,
          path: '/aigc/chat_group/add/',
          params: {
            title: this.form.title,
            agent_id: this.agent_id
          },
          success: function (data) {
            t.isVisible = false;
            t.$emit('refresh')
          }
        }
      )
    },
  }
}
</script>

<style scoped >
@import '../../assets/global.css';
</style>

